import { render } from "./CropMineralFertilization.vue?vue&type=template&id=34d34931&scoped=true&ts=true"
import script from "./CropMineralFertilization.vue?vue&type=script&lang=ts"
export * from "./CropMineralFertilization.vue?vue&type=script&lang=ts"

import "./CropMineralFertilization.vue?vue&type=style&index=0&id=34d34931&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34d34931"]])

export default __exports__